module.exports = __webpack_public_path__ + "6495bda5.svg";